export default __webpack_public_path__ + "static/media/dna.d7ab4974.png";